require('./externalTransferFundStep1.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ commons
const { InputSafe } = require('commonsComponents/inputSafe');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
// @ components
const {
    DOCUMENT_NUMBER_NIF_PASSPORT_MAX_CHARS,
    ZERO_UP_TO_SIXTY_ALL_CHARACTERS,
} = require('constants/index');
class ExternalTransferFundStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleSetInstitutionName = this.handleSetInstitutionName.bind(this);
        this.handleSetAccount = this.handleSetAccount.bind(this);
        this.handleSetNif = this.handleSetNif.bind(this);
        this.chooseHandler = this.chooseHandler.bind(this);
    }

    buildInput(input) {
        const { immExternalTransferFund } = this.props;
        const data = immExternalTransferFund.getIn(['steps', 0, input]);
        const dirty = immExternalTransferFund.getIn(['steps', 0, input + 'Dirty']);
        const isValid = immExternalTransferFund.getIn(['steps', 0, input + 'IsValid']);
        const handler = this.chooseHandler(input);
        return (
            <div className={'external-transfer-fund-step1__input-' + input}>
                <FormattedText
                    value={'brokerExternalTransferFundStep1-' + input + 'InputLabel'}
                    className="external-transfer-fund-step1__box-title"
                />
                <div className="external-transfer-fund-step1__tooltip">
                    <OKTooltip
                        content={formatText(
                            'brokerExternalTransferFundStep1-' + input + 'Tooltip'
                        )}
                        offset={[0,-15]}
                    />
                </div>
                <InputSafe
                    type="text"
                    value={data}
                    onChange={handler}
                    placeholder={formatText(
                        'brokerExternalTransferFundStep1-' + input + 'Placeholder'
                    )}
                    errorState={!isValid && !dirty}
                    errorMessage={formatText('brokerExternalTransferFundStep1-' + input + 'Error')}
                />
            </div>
        );
    }

    chooseHandler(input) {
        switch (input) {
            case 'institution':
                return this.handleSetInstitutionName;
            case 'account':
                return this.handleSetAccount;
            case 'nif':
                return this.handleSetNif;
        }
    }
    handleSetAccount(event) {
        this.props.setAccount(event.target.value.toUpperCase());
    }
    handleSetInstitutionName(event) {
        if (ZERO_UP_TO_SIXTY_ALL_CHARACTERS.test(event.target.value)) {
            this.props.setInstitutionName(event.target.value);
        }
    }

    handleSetNif(event) {
        const value = event.target.value;
        this.props.setNif((value + '').substr(0, DOCUMENT_NUMBER_NIF_PASSPORT_MAX_CHARS));
    }

    render() {
        const { immExternalTransferFund } = this.props
        const accountInput = this.buildInput('account');
        const shouldHasNif = immExternalTransferFund.getIn(['steps', 0, 'hasNif']);
        const nifInput = shouldHasNif ? this.buildInput('nif') : null;
        const link = formatText('disclaimerPersonalInfo-traspasoGdprDisclaimerLinkUrl');

        return (
            <div className="external-transfer-fund-step1">
                <FormattedText
                    value="brokerExternalTransferFundStep1-formTitle"
                    className="external-transfer-fund-step1__title"
                />
                {accountInput}
                {nifInput}
                <div className="external-transfer-fund-step1__container">
                    <div className="hire-investment-step1__disclaimer-personal-info col-xs-12">
                        <OKMessage type="informative">
                            <FormattedText value="disclaimerPersonalInfo-traspasoGdprDisclaimerText" />
                            &nbsp;
                            <OKLink to={link} target="_blank" modifier="emphasize">
                                <FormattedText value="disclaimerPersonalInfo-traspasoGdprDisclaimerLinkText" />
                            </OKLink>
                        </OKMessage>
                    </div>
                    <div className="clearfix" />
                </div>
            </div>
        );
    }
}

ExternalTransferFundStep1.propTypes = {
    immExternalTransferFund: PropTypes.object.isRequired,
    setInstitutionName: PropTypes.func.isRequired,
    setAccount: PropTypes.func.isRequired,
    setNif: PropTypes.func.isRequired,
    noDestinationFunds: PropTypes.bool.isRequired,
};

module.exports = ExternalTransferFundStep1;
